// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wpcm-reward-images {\n  margin-top: 20px;\n  text-align: center;\n}\n.reward-preview {\n  padding: 15px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n.reward-image {\n  max-width: 200px;\n  height: auto;\n  margin-bottom: 10px;\n}\n.reward-description {\n  font-size: 14px;\n  color: #666;\n  margin: 5px 0;\n}\n", ""]);
// Exports
module.exports = exports;
